import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import LinkList from './pages/LinkList';
import Privacy from './pages/Privacy';
import Features from './components/Features';
import FeaturesPage from './pages/FeaturesPage';
import ReactGA from 'react-ga4';
ReactGA.initialize('G-Q5E5DTFPJD');
ReactGA.send({ hitType: "pageview", page: "/", title: "HeadsUp Landing Page" });
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/link/:slug",
    element: <LinkList />
  },
  {
    path: "/privacy",
    element: <Privacy />
  },
  {
    path:"/features",
    element: <FeaturesPage/>
  }
]);
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <RouterProvider router={router} />
    </ChakraProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
